/* eslint-disable no-console */
import moment from 'moment';

import firebase from '../../firebase';
import {
  loadSubscription,
  selectApp,
} from '../../app/modules/appContext/actions';
import { receiveCustomDomain } from '../../app/modules/customDomain/actions';
import { resetEngageState } from '../../modules/engage/modules/push/actions';
import { getAppUrl } from '../../utils/appDetails';
import {
  updateContact,
  getListByPlanName,
} from '../account/modules/auth/login/actions';
import { getAllComponents } from './modules/build/modules/create/createComponent/actions';
import { loadProfile } from '../account/modules/auth/login/actions';
import { updateAccount } from '../account/actions';
import { fetchAppPreference } from '../../app/modules/appPreference/action';
import { openSnackbar } from '../../app/modules/snackbar/actions';

export const SAVE_APP_NAME = 'SAVE_APP_NAME';

export const noticeSet = () => ({
  type: 'OFFER_NOTICE_SET',
});

const receiveLayoutData = (appname, data) => ({
  type: 'RECEIVE_LAYOUT_DATA',
  data,
  appname,
});

const changingApp = appname => ({
  type: 'CHANGING_APP',
  appname,
});

const appChangeSuccess = appname => ({
  type: 'APP_CHANGE_SUCCESS',
  appname,
});

const appChangeError = (appname, err) => ({
  type: 'APP_CHANGE_ERROR',
  appname,
  err,
});

export const toggleAppMenu = open => ({
  type: 'TOGGLE_APP_MENU',
  open,
});

export const toggleUserMenu = open => ({
  type: 'TOGGLE_USER_MENU',
  open,
});

export const changeApp = (appname, oldAppname) => (dispatch, getState) => {
  const user = firebase.auth().currentUser;
  dispatch(changingApp(appname));
  return firebase
    .database()
    .ref(`users/${user.uid}`)
    .update({ lastVisited: appname })
    .then(() => dispatch(selectApp(appname)))
    .then(() => dispatch(resetEngageState()))
    .then(() => dispatch(removeListeners(oldAppname)))
    .then(() => dispatch(loadContent(appname)))
    .then(() => dispatch(appChangeSuccess(appname)))
    .then(() => dispatch(loadProfile()))
    .then(() => dispatch(loadSubscription(appname)))
    .then(() => dispatch(fetchAppPreference(appname)))
    .then(() => {
      const currentPlan =
        getState().app.appContext.subscription || 'free_trial';
      const account = getState().account.profile.account || '';

      const lists = getListByPlanName(
        currentPlan,
        getState().account.organisation,
      );

      return dispatch(updateContact({ account, appname, currentPlan, lists }));
    })
    .catch(err => dispatch(appChangeError(appname, err)));
};

const saveIntegrationAppData = (meta, appname) => ({
  type: SAVE_APP_NAME,
  meta,
  appname,
});

const receiveAlwaysData = (data, key) => ({
  type: 'RECEIVE_ALWAYS_DATA',
  data,
  key,
});

const receiveLazyData = (data, key) => ({
  type: 'RECEIVE_LAZY_DATA',
  data,
  key,
});

const receiveMetaData = (appname, data) => ({
  type: 'RECEIVE_META_DATA',
  data,
  appname,
});

const receiveDesignData = (appname, data) => ({
  type: 'RECEIVE_DESIGN_DATA',
  data,
  appname,
});

const receiveDraftData = data => ({
  type: 'RECEIVE_DRAFT_DATA',
  data,
});

const hydrateAlwaysData = data => ({
  type: 'HYDRATE_ALWAYS_DATA',
  data,
});

const hydrateLazyData = data => ({
  type: 'HYDRATE_LAZY_DATA',
  data,
});

const loadingContent = appname => ({
  type: 'LOADING_DRAFT_CONTENT',
  appname,
});

const contentLoaded = appname => ({
  type: 'DRAFT_CONTENT_LOADED',
  appname,
});

const modifyEditionStart = (appname, start) => ({
  type: 'DRAFT_EDITION_START_MODIFIED',
  appname,
  start,
});

export const receiveEditionDate = (appname, start) => ({
  type: 'RECEIVE_DRAFT_EDITION_START',
  start,
  appname,
});

const loadingIcon = appname => ({
  type: 'LOADING_ICON_CONTENT',
  appname,
});

const hydrateIconData = (data, appname) => ({
  type: 'HYDRATE_ICON_DATA',
  data,
  appname,
});

const integrationNodeUpdated = account => ({
  type: 'INTEGRATION_NODE_UPDATED',
  account,
});

const integrationNodeFailUpdated = account => ({
  type: 'INTEGRATION_NODE_FAIL_UPDATED',
  account,
});

const receivePreviusPublishedDomain = (appname, previusDomain) => ({
  type: 'PREVIUS_PUBLISHED_DOMAIN',
  previusDomain,
  appname,
});

const receivePaypalData = (appname, paypal) => ({
  type: 'RECEIVE_PAYPAL_DATA',
  paypal,
  appname,
});

const intanceIdInvalid = appname => ({
  type: 'WIX_INSTANCE_ID_INVALID',
  appname,
});

const receiveGaTrackingId = gaTrackingId => ({
  type: 'RECEIVE_GA_TRACKING_ID',
  data: gaTrackingId,
});

export const checkUsersSubscription = appname => async dispatch => {
  try {
    const sub = await firebase
      .database()
      .ref(`apps/${appname}/subscription`)
      .once('value')
      .then(snapshot => snapshot.val());

    if (sub) {
      return dispatch({
        type: 'SAVE_USER_SUBSCRIPTION',
        isUserSubscribed: true,
      });
    }

    return dispatch({
      type: 'SAVE_USER_SUBSCRIPTION',
      isUserSubscribed: false,
    });
  } catch (error) {
    dispatch({
      type: 'FAILED_SAVING_USER_SUBSCRIPTION',
      error,
    });
    return console.error(error);
  }
};

export const receivePublished = (appname, isPublished) => ({
  type: 'IS_PUBLISHED',
  appname,
  isPublished,
});

export const addIsPublishedListener = appname => dispatch => {
  const appRef = firebase.database().ref(`apps/${appname}`);

  appRef
    .child('published/meta_data')
    .on('value', snapshot =>
      dispatch(receivePublished(appname, snapshot.val() !== null)),
    );

  appRef
    .child('published/meta_data')
    .once('value')
    .then(snapshot =>
      dispatch(receivePublished(appname, snapshot.val() !== null)),
    );
};

export const removeIsPublishedListener = appname => {
  const appRef = firebase.database().ref(`apps/${appname}`);
  appRef.child('published/meta_data').off('value');

  return {
    type: 'REMOVE_IS_PUBLISHED_LISTENER',
    appname,
  };
};

export const loadIcon = appname => dispatch => {
  dispatch(loadingIcon(appname));

  const iconRef = firebase.database().ref(`icons/${appname}/`);
  // we load all draft data once before attaching listeners
  iconRef.once('value').then(iconSnapshot => {
    const data = iconSnapshot.val();
    dispatch(hydrateIconData(data, appname));

    // listen for changes to icon
    return iconRef.on('value', snapshot => {
      const nextData = snapshot.val();
      dispatch(hydrateIconData(nextData, appname));
    });
  });
};

const PAGE_LIST_CACHE_PREFIX = 'beezer:editor:pageList:';

const readPageListCache = appname => {
  try {
    const raw = sessionStorage.getItem(`${PAGE_LIST_CACHE_PREFIX}${appname}`);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const writePageListCache = (appname, layoutData, alwaysData) => {
  try {
    if (!layoutData || !alwaysData) return;

    const pageKeys = [
      ...(layoutData.childRoutes || []),
      layoutData.index,
    ].filter(Boolean);
    const pages = {};

    pageKeys.forEach(key => {
      const page = alwaysData[key];
      if (!page) return;
      pages[key] = {
        title: page.title,
        type: page.type,
        hidden: page.hidden,
        parentPageKey: page.parentPageKey,
        order: page.order,
        isHomepage: page.isHomepage,
        components: page.components,
        tabs: page.tabs,
        hasUnavailaleComponent: page.hasUnavailaleComponent,
      };
    });

    sessionStorage.setItem(
      `${PAGE_LIST_CACHE_PREFIX}${appname}`,
      JSON.stringify({ layout_data: layoutData, always_data: pages }),
    );
  } catch (e) {
    // Ignore quota / private-mode failures.
  }
};

const withAlwaysDataKeys = alwaysData => {
  if (!alwaysData) return alwaysData;

  // Single-pass copy — avoid O(n²) spreads on large apps.
  const next = {};
  Object.keys(alwaysData).forEach(dataId => {
    next[dataId] = {
      ...alwaysData[dataId],
      key: dataId,
    };
  });
  return next;
};

const getPageComponentKeys = pageData => {
  if (!pageData) return [];

  let keys = pageData.components || [];
  if (Array.isArray(pageData.tabs)) {
    pageData.tabs.forEach(tab => {
      if (tab && Array.isArray(tab.components)) {
        keys = keys.concat(tab.components);
      }
    });
  }
  return [...new Set(keys.filter(Boolean))];
};

const getOpenPageKey = layoutData => {
  let fromUrl = null;
  try {
    fromUrl = new URLSearchParams(window.location.search).get('page');
  } catch (e) {
    // ignore
  }

  // Tour / older links use the literal "homepage" key.
  if (fromUrl && fromUrl !== 'homepage') {
    return fromUrl;
  }

  if (fromUrl === 'homepage') {
    return (layoutData && layoutData.index) || 'homepage';
  }

  // Default to the real homepage, then the first page in the menu order.
  if (layoutData && layoutData.index) {
    return layoutData.index;
  }

  if (
    layoutData &&
    Array.isArray(layoutData.childRoutes) &&
    layoutData.childRoutes.length
  ) {
    return layoutData.childRoutes[0];
  }

  return null;
};

// Background full-tree sync must not run while the user is switching pages —
// a single RTDB WebSocket means the huge download starves small page fetches.
const backgroundAlwaysSync = {
  timer: null,
  started: false,
  completed: false,
  context: null,
};

const pauseBackgroundAlwaysSync = () => {
  if (backgroundAlwaysSync.timer) {
    clearTimeout(backgroundAlwaysSync.timer);
    backgroundAlwaysSync.timer = null;
  }
};

const runBackgroundAlwaysSync = () => {
  const ctx = backgroundAlwaysSync.context;
  if (
    !ctx ||
    backgroundAlwaysSync.started ||
    backgroundAlwaysSync.completed
  ) {
    return;
  }

  backgroundAlwaysSync.started = true;
  const {
    dispatch,
    getState,
    appname,
    layout_data,
    appRef,
    draftRef,
    layoutDataRef,
    alwaysDataRef,
    metaDataRef,
    designDataRef,
    appPreviusDomain,
  } = ctx;

  alwaysDataRef
    .once('value')
    .then(alwaysSnap => {
      const always_data = withAlwaysDataKeys(alwaysSnap.val());

      dispatch(hydrateAlwaysData(always_data));
      dispatch(
        receiveDraftData({
          layout_data,
          always_data,
        }),
      );
      writePageListCache(appname, layout_data, always_data);

      attachDraftListeners(dispatch, getState, appname, {
        appRef,
        draftRef,
        layoutDataRef,
        alwaysDataRef,
        metaDataRef,
        designDataRef,
        appPreviusDomain,
        always_data,
      });

      backgroundAlwaysSync.completed = true;
      return null;
    })
    .catch(() => {
      // Allow a later retry after the next page interaction.
      backgroundAlwaysSync.started = false;
    });
};

const scheduleBackgroundAlwaysSync = (delayMs = 12000) => {
  if (backgroundAlwaysSync.completed || backgroundAlwaysSync.started) {
    return;
  }
  if (!backgroundAlwaysSync.context) return;

  pauseBackgroundAlwaysSync();
  backgroundAlwaysSync.timer = setTimeout(() => {
    backgroundAlwaysSync.timer = null;
    runBackgroundAlwaysSync();
  }, delayMs);
};

// Use REST so page switches are not queued behind a large WS always_data download.
const fetchDraftNodeRest = path => {
  const base =
    (firebase.options && firebase.options.databaseURL) ||
    process.env.REACT_APP_FIREBASE_DATABASE_URL;
  const user = firebase.auth && firebase.auth().currentUser;
  if (!base || !user) {
    return Promise.reject(new Error('REST draft fetch unavailable'));
  }

  return user.getIdToken().then(token =>
    fetch(`${base}/${path}.json?auth=${encodeURIComponent(token)}`).then(
      response => {
        if (!response.ok) {
          throw new Error(`REST draft fetch failed (${response.status})`);
        }
        return response.json();
      },
    ),
  );
};

const fetchAlwaysNode = (appname, key) => {
  const path = `apps/${appname}/draft/always_data/${key}`;
  const sdkFallback = () =>
    firebase
      .database()
      .ref(path)
      .once('value')
      .then(snap => snap.val());

  // Prefer REST so page switches never queue behind a large WS sync.
  return fetchDraftNodeRest(path).catch(sdkFallback);
};

const fetchLazyNode = (appname, key) => {
  const path = `apps/${appname}/draft/lazy_data/${key}`;
  const sdkFallback = () =>
    firebase
      .database()
      .ref(path)
      .once('value')
      .then(snap => snap.val());

  return fetchDraftNodeRest(path).catch(sdkFallback);
};

// Load one page + its components + only that page's lazy payloads.
// Kept small on purpose so it is not starved by full-tree downloads.
export const loadPageEditorContent = (
  appname,
  pageKey,
) => (dispatch, getState) => {
  if (!pageKey) return Promise.resolve(null);

  // Keep exclusive bandwidth for the page the user just opened.
  pauseBackgroundAlwaysSync();

  const existingPage = getState().editor.data.alwaysData[pageKey];
  const existingComponentKeys = getPageComponentKeys(existingPage);
  const componentsAlreadyLoaded =
    existingPage &&
    existingComponentKeys.length > 0 &&
    existingComponentKeys.every(key => !!getState().editor.data.alwaysData[key]);

  // Always refresh the page node from the network unless its components are
  // already fully present — session cache stubs must not block a real fetch.
  const pagePromise = componentsAlreadyLoaded
    ? Promise.resolve(existingPage)
    : fetchAlwaysNode(appname, pageKey).then(pageData => {
        if (!pageData) {
          // Fallback: literal "homepage" vs layout.index mismatch
          if (pageKey !== 'homepage') {
            return fetchAlwaysNode(appname, 'homepage').then(homeData => {
              if (!homeData) return null;
              dispatch(
                hydrateAlwaysData({
                  homepage: { ...homeData, key: 'homepage' },
                  [pageKey]: { ...homeData, key: pageKey },
                }),
              );
              return homeData;
            });
          }
          return null;
        }
        dispatch(
          hydrateAlwaysData({
            [pageKey]: { ...pageData, key: pageKey },
          }),
        );
        return pageData;
      });

  return pagePromise
    .then(pageData => {
      if (!pageData) return null;

      const componentKeys = getPageComponentKeys(pageData);
      const missingComponentKeys = componentKeys.filter(
        key => !getState().editor.data.alwaysData[key],
      );

      // Hydrate components as each arrives so the list can paint progressively.
      const componentsPromise = missingComponentKeys.length
        ? Promise.all(
            missingComponentKeys.map(key =>
              fetchAlwaysNode(appname, key).then(val => {
                if (val) {
                  dispatch(
                    hydrateAlwaysData({
                      [key]: { ...val, key },
                    }),
                  );
                }
                return [key, val];
              }),
            ),
          )
        : Promise.resolve([]);

      return componentsPromise.then(() => {
        const lazyIds = componentKeys
          .map(key => {
            const component = getState().editor.data.alwaysData[key];
            return component && component.lazy_data;
          })
          .filter(
            id => id && getState().editor.data.lazyData[id] === undefined,
          );

        if (!lazyIds.length) return null;

        return Promise.all(
          lazyIds.map(id =>
            fetchLazyNode(appname, id).then(val => {
              if (val != null) {
                dispatch(receiveLazyData(val, id));
              }
            }),
          ),
        );
      });
    })
    .then(result => {
      // Resume full-tree sync only after the user stops switching pages.
      scheduleBackgroundAlwaysSync(12000);
      return result;
    })
    .catch(err => {
      scheduleBackgroundAlwaysSync(12000);
      throw err;
    });
};

const attachDraftListeners = (
  dispatch,
  getState,
  appname,
  {
    appRef,
    draftRef,
    layoutDataRef,
    alwaysDataRef,
    metaDataRef,
    designDataRef,
    appPreviusDomain,
    always_data,
  },
) => {
  let structureRebuildTimer = null;
  const scheduleStructureRebuild = () => {
    if (structureRebuildTimer) {
      clearTimeout(structureRebuildTimer);
    }
    structureRebuildTimer = setTimeout(() => {
      dispatch(getAllComponents(appname));
    }, 250);
  };

  layoutDataRef.on('value', snapshot => {
    dispatch(receiveLayoutData(appname, snapshot.val()));
    scheduleStructureRebuild();
  });

  metaDataRef.on('value', snapshot =>
    dispatch(receiveMetaData(appname, snapshot.val())),
  );

  designDataRef.on('value', snapshot => {
    dispatch(receiveDesignData(appname, snapshot.val()));
    const accountOrg = getState().account;
    const adminAppName = accountOrg.profile.admin_appname;
    const isAdminApp = (adminAppName && adminAppName.length > 0) || false;
    const data = { appname };
    data[`{${appname}} template`] = snapshot.val().skin;
  });

  const hydratedAlwaysKeys = new Set(Object.keys(always_data || {}));

  alwaysDataRef.on('child_added', snapshot => {
    if (hydratedAlwaysKeys.has(snapshot.key)) {
      return;
    }
    dispatch(receiveAlwaysData(snapshot.val(), snapshot.key));
    scheduleStructureRebuild();
  });

  alwaysDataRef.on('child_changed', snapshot => {
    dispatch(receiveAlwaysData(snapshot.val(), snapshot.key));
    scheduleStructureRebuild();
  });

  appPreviusDomain.on('value', previusDomain =>
    dispatch(receivePreviusPublishedDomain(appname, previusDomain.val())),
  );

  draftRef.on('child_changed', () => {
    let modifiedOn = moment(new Date()).valueOf();

    appRef.child('edition/start').transaction(date => {
      modifiedOn = date || modifiedOn;
      dispatch(modifyEditionStart(appname, modifiedOn));
      return modifiedOn;
    });
  });
};

export const loadContent = appname => (dispatch, getState) => {
  dispatch(loadingContent(appname));
  dispatch(loadIcon(appname));

  // Reset per-app background sync bookkeeping.
  pauseBackgroundAlwaysSync();
  backgroundAlwaysSync.started = false;
  backgroundAlwaysSync.completed = false;
  backgroundAlwaysSync.context = null;

  // Paint page list immediately from the last visit in this browser session.
  const cached = readPageListCache(appname);
  if (cached && cached.layout_data && cached.always_data) {
    dispatch(hydrateAlwaysData(cached.always_data));
    dispatch(receiveLayoutData(appname, cached.layout_data));
    dispatch(receiveDraftData(cached));
  }

  const appRef = firebase.database().ref(`apps/${appname}`);
  const draftRef = appRef.child('draft');
  const customDomainRef = appRef.child('custom_domain');
  const gaRef = appRef.child('gaTrackingId');
  const layoutDataRef = draftRef.child('layout_data');
  const alwaysDataRef = draftRef.child('always_data');
  const metaDataRef = draftRef.child('meta_data');
  const designDataRef = draftRef.child('design_data');
  const appPreviusDomain = appRef.child('previus_published_domain');
  const appPaypalData = appRef.child('paypal');

  customDomainRef.once('value').then(snapshot => {
    customDomainRef.on('value', sp => {
      const customDomain = sp.val();

      return dispatch(receiveCustomDomain(customDomain));
    });

    const customDomain = snapshot.val();

    return dispatch(receiveCustomDomain(customDomain));
  });

  appPreviusDomain
    .once('value')
    .then(previusDomain =>
      dispatch(receivePreviusPublishedDomain(appname, previusDomain.val())),
    );

  gaRef.once('value').then(snapshot => {
    const gaTrackingId = snapshot.val();

    return dispatch(receiveGaTrackingId(gaTrackingId));
  });

  appPaypalData
    .once('value')
    .then(data => dispatch(receivePaypalData(appname, data.val())));

  // Small nodes only — do NOT start full always/lazy yet (they starve the open page).
  const layoutPromise = layoutDataRef.once('value');
  const metaPromise = metaDataRef.once('value');
  const designPromise = designDataRef.once('value');

  return layoutPromise.then(layoutSnap => {
    const layout_data = layoutSnap.val();
    if (layout_data === null) return null;

    dispatch(receiveLayoutData(appname, layout_data));

    const openPageKey = getOpenPageKey(layout_data);

    // 1) Exclusive bandwidth for the page the user is looking at.
    return dispatch(loadPageEditorContent(appname, openPageKey)).then(() => {
      // Unlock editor UI as soon as the open page is usable.
      dispatch(contentLoaded(appname));

      metaPromise.then(metaSnap =>
        dispatch(receiveMetaData(appname, metaSnap.val())),
      );
      designPromise.then(designSnap =>
        dispatch(receiveDesignData(appname, designSnap.val())),
      );

      // Cache sidebar page titles without pulling component trees.
      const pageKeys = [
        ...(layout_data.childRoutes || []),
        layout_data.index,
      ].filter(Boolean);
      const cachedAlways = getState().editor.data.alwaysData || {};
      const missingMenuKeys = pageKeys
        .filter(key => !cachedAlways[key])
        .slice(0, 40);

      if (missingMenuKeys.length) {
        // Stagger lightly so we don't spike the socket right after first paint.
        setTimeout(() => {
          if (backgroundAlwaysSync.started) return;
          Promise.all(
            missingMenuKeys.map(key =>
              fetchAlwaysNode(appname, key).then(val => [key, val]),
            ),
          ).then(entries => {
            const pagesOnly = {};
            entries.forEach(([key, val]) => {
              if (val) pagesOnly[key] = { ...val, key };
            });
            if (Object.keys(pagesOnly).length) {
              dispatch(hydrateAlwaysData(pagesOnly));
              writePageListCache(appname, layout_data, {
                ...getState().editor.data.alwaysData,
                ...pagesOnly,
              });
            }
          });
        }, 1500);
      }

      // 2) Full always_data only after the user stops switching pages for a bit.
      // Starting it immediately was causing ~50s waits on the second page click.
      backgroundAlwaysSync.started = false;
      backgroundAlwaysSync.completed = false;
      backgroundAlwaysSync.context = {
        dispatch,
        getState,
        appname,
        layout_data,
        appRef,
        draftRef,
        layoutDataRef,
        alwaysDataRef,
        metaDataRef,
        designDataRef,
        appPreviusDomain,
      };
      scheduleBackgroundAlwaysSync(12000);

      return null;
    });
  });
};

export const widgetConfiguration = (appname, type) => dispatch => {
  if (type !== 'Wix') {
    return;
  }
  const instanceId = window.Wix.Utils.getInstanceId();
  try {
    if (instanceId) {
      firebase
        .database()
        .ref(`integration/wix/${instanceId}`)
        .update({
          appname,
          url: getAppUrl(appname),
        });
      dispatch(integrationNodeUpdated(instanceId));
    } else {
      dispatch(intanceIdInvalid(appname));
    }
  } catch (err) {
    dispatch(integrationNodeFailUpdated(instanceId));
  }
};

export const removeListeners = appname => {
  pauseBackgroundAlwaysSync();
  backgroundAlwaysSync.started = false;
  backgroundAlwaysSync.completed = false;
  backgroundAlwaysSync.context = null;

  const iconRef = firebase.database().ref(`icons/${appname}/`);
  const draftRef = firebase.database().ref(`apps/${appname}/draft`);
  const layoutDataRef = draftRef.child('layout_data');
  const alwaysDataRef = draftRef.child('always_data');
  const lazyDataRef = draftRef.child('lazy_data');
  const metaDataRef = draftRef.child('meta_data');
  const designDataRef = draftRef.child('design_data');
  const appPreviusDomain = firebase
    .database()
    .ref(`apps/${appname}/previus_published_domain`);
  const accessibilitySettingsRef = firebase
    .database()
    .ref(`apps/${appname}/draft/always_data/accessibility`);

  layoutDataRef.off('value');

  alwaysDataRef.off('child_added');
  alwaysDataRef.off('child_changed');
  lazyDataRef.off('child_added');
  lazyDataRef.off('child_changed');
  appPreviusDomain.off('value');
  metaDataRef.off('value');

  designDataRef.off('value');
  draftRef.off('child_changed');
  iconRef.off('value');
  accessibilitySettingsRef.off('value');
  return {
    type: 'REMOVE_APP_LISTENERS',
    appname,
  };
};

export const saveMetaData = (appname, nextState) => dispatch => {
  const user = firebase.auth().currentUser;

  firebase
    .database()
    .ref(`users/${user.uid}/account`)
    .on('value', snapshot => {
      const accountName = snapshot.val();
      firebase
        .database()
        .ref(`accounts/${accountName}/apps/${appname}`)
        .update({ title: nextState.title });
    });

  const metaDataRef = firebase
    .database()
    .ref(`apps/${appname}/draft/meta_data`);
  metaDataRef.update(nextState);
  dispatch(saveIntegrationAppData(nextState, appname));
};

export const addOfferNotice = (offer, account) => (dispatch, getState) => {
  let content = '';
  let mobileContent = '';

  const accountOrg = getState().account;
  const isAppAdmin =
    (getState().account.auth.profile.admin_appname &&
      getState().account.auth.profile.admin_appname.length > 0) ||
    false;

  if (
    !accountOrg.organisation.appsumo_id &&
    !isAppAdmin &&
    !offer.coupon === 'lifetime'
  ) {
    if (offer && offer.coupon) {
      if (
        offer.coupon === 'lifetime' &&
        accountOrg &&
        accountOrg.organisation &&
        accountOrg.organisation.offerEligibility &&
        (accountOrg.organisation.offerEligibility.lifetime === false ||
          accountOrg.organisation.offerEligibility.lifetime === true)
      ) {
        return;
      }

      content = offer.welcome_notice;
      mobileContent = offer.welcome_notice_mobile || '';
    }

    dispatch({ type: 'ADDING_OFFER_NOTICE' });

    firebase
      .database()
      .ref(`accounts/${account}`)
      .child('notices')
      .push({ content, mobileContent, type: 'Offer', autoPopup: true })
      .catch(err => console.error(err));
  }
};

export const savePaypalData = (appname, nextState) => dispatch => {
  console.log('nextState-->', nextState);
  const metaDataRef = firebase.database().ref(`apps/${appname}/paypal`);
  metaDataRef.update(nextState).then(() => {
    dispatch(openSnackbar(`Paypal settings updated.`));
  });
};

export const addPageContentUpdateListner = (
  appname,
  currentPage,
  prevPage,
) => dispatch => {
  const appRef = firebase.database().ref(`apps/${appname}`);
  const draftRef = appRef.child('draft');
  const alwaysDataRef = draftRef.child('always_data');
  if (alwaysDataRef && currentPage) {
    const currentPageDataRef = alwaysDataRef.child(currentPage);
    const prevPageDataRef = prevPage ? alwaysDataRef.child(prevPage) : null;
    dispatch({ type: 'COMPONENT_UPDATED', currentPage, appname });
    draftRef.once('value').then(draftSnapshot => {
      const data = draftSnapshot.val();

      if (data === null) return null;

      if (prevPageDataRef) {
        prevPageDataRef.off('value');
      }

      currentPageDataRef.on('value', snapshot => {
        if (
          snapshot.val().isUpdateAvailable === undefined ||
          !snapshot.val().isUpdateAvailable
        ) {
          currentPageDataRef.update({
            isUpdateAvailable: true,
          });
        }
      });

      return null;
    });
  }
};

export const isAppValid = appname => async (dispatch, getState) => {
  dispatch({
    type: 'VALIDATING_APP',
  });
  const appStructure = getState().editor.structure;
  const subscriptions = getState().account.subscriptions;
  const isWixUser =
    getState().account.integration &&
    getState().account.integration.type === 'Wix';
  const accountId = getState().account.organisation.key;
  const subscription = subscriptions.items[appname];
  const underReview = getState().account.organisation.underReview;
  const passedReview = getState().account.organisation.passedReview;
  const hasPlan =
    subscription && subscription.plan && subscription.plan !== 'free';

  if (passedReview && !underReview && !hasPlan && !isWixUser) {
    dispatch({
      type: 'APP_VALIDATION_DONE',
    });
    return true;
  }

  if (hasPlan || isWixUser || appStructure.routes.length > 1) {
    dispatch({
      type: 'APP_VALIDATION_DONE',
    });
    return true;
  } else {
    const headers = new Headers();
    const user = firebase.auth().currentUser;
    const body = JSON.stringify({
      appname,
      accountId,
    });
    user.getIdToken().then(token => {
      headers.append('Content-Type', 'application/json');
      headers.append('x-access-token', token);
      fetch(`${process.env.REACT_APP_ACCOUNT_API}/account-under-review`, {
        method: 'post',
        headers,
        body,
        mode: 'cors',
      })
        .then(() => {
          dispatch(updateAccount('underReview', true));
          dispatch(updateAccount('passedReview', null));
        })
        .catch(err => console.error(err));
    });
    dispatch({
      type: 'APP_VALIDATION_DONE',
    });
    return false;
  }
};
